<template>
  <el-dialog
    title="选择入库方式"
    :visible.sync="dialogVisible"
    width="300px"
  >
    <el-radio-group v-model="selectedOption">
      <el-radio label="1">PC入库</el-radio>
      <el-radio label="2">PDA入库</el-radio>
    </el-radio-group>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false" style="margin-right: 10px;">取消</el-button>
      <el-button type="primary" @click="submit">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      selectedOption: '',
      rowData: {},
      url: 'Purchase/index',
      act: 'create_storage_check'
    };
  },
  methods: {
    openDialog(row, url, act) {
      this.rowData = row
      if (url) {
        this.url = url;
      }
      if (act) {
        this.act = act;
      }
      this.dialogVisible = true;
    },
    async submit() {
      if (this.selectedOption) {
        const res = await this.$axios({
          url: this.GLOBAL.domain + this.url,
          method: "post",
          data: {
            act: this.act,
            id: this.rowData.id,
            type: this.selectedOption
          }
        });
        if (res.Message == 'ok') {
          this.dialogVisible = false;
          this.$emit('confirm', { row: this.rowData, type: this.selectedOption });
          this.selectedOption = '';
        } else {
          const isPda = /当前已存在PDA入库任务/.test(res.Message)
          this.$confirm(res.Message, '提示', {
            confirmButtonText: !isPda ? '确定' : '知道了',
            showCancelButton: !isPda,
            type: 'warning',
            cancelButtonText: '取消'
          })
            .then(() => {
              if (!isPda) {
                // 用户点击确定，继续执行 emit 操作
                this.dialogVisible = false;
                this.$emit('confirm', { row: this.rowData, type: this.selectedOption });
                this.selectedOption = '';
              }
            })
            .catch(() => {
              // 用户点击取消，关闭 dialogVisible 弹窗
              this.selectedOption = '';
              this.dialogVisible = false;
            });
        }
      } else {
        this.$message.warning('请选择入库方式');
      }
    },
    confirmSelection() {
      if (this.selectedOption) {
        this.$message.success(`已选择：${this.selectedOption}`);
        this.selectedOption = ''
        this.dialogVisible = false;
      } else {
        this.$message.warning('请选择入库方式');
      }
    }
  }
};
</script>

<style scoped>
.el-radio-group {
  margin-bottom: 20px;
}
.dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/purchase/checkInStore.vue